<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<line x1="19.2929" y1="21" x2="14" y2="15.7071" stroke="#458EAF" stroke-linecap="round"/>
	<circle cx="9.5" cy="10.5" r="6" stroke="#458EAF"/>
</svg>
</template>
